<mat-toolbar class="header-toolbar">
  <div class="header-left">
    <button
      mat-icon-button
      (click)="toggleSidebar.emit()"
      class="header-icon-btn menu-toggle"
      matTooltip="Toggle menu"
      matTooltipPosition="below"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <img src="assets/img/eliqua-logo.png" alt="Liquid" class="header-logo" (click)="goHome()" />
  </div>

  <div class="header-right">
    <button
      mat-icon-button
      (click)="alioDrawer.toggle()"
      class="header-icon-btn alio-toggle-button"
      [class.alio-active]="alioDrawer.isOpen$ | async"
      [matTooltip]="(alioDrawer.isOpen$ | async) ? 'Close alio AI' : 'Ask alio AI'"
      matTooltipPosition="below"
      aria-label="Toggle alio AI agent"
    >
      <mat-icon class="alio-icon">chat</mat-icon>
    </button>

    <button
      mat-icon-button
      [matMenuTriggerFor]="activityMenu"
      class="header-icon-btn activity-button"
      matTooltip="Activity log"
      matTooltipPosition="below"
      (click)="activityLog.markAllRead()"
    >
      <mat-icon
        [matBadge]="(activityLog.unreadCount$ | async) || null"
        matBadgeColor="warn"
        matBadgeSize="small"
        [matBadgeHidden]="(activityLog.unreadCount$ | async) === 0"
        aria-hidden="false"
        [attr.aria-label]="
          'Notifications: ' + ((activityLog.unreadCount$ | async) || 0) + ' unread'
        "
        >notifications</mat-icon
      >
    </button>
    <mat-menu #activityMenu="matMenu" class="activity-menu-panel">
      <div class="activity-menu-header" (click)="$event.stopPropagation()">
        <span>Activity</span>
        <button mat-button class="activity-clear-btn" (click)="activityLog.clearAll()">
          Clear
        </button>
      </div>
      <div class="activity-menu-body" (click)="$event.stopPropagation()">
        @if ((activityLog.entries$ | async)?.length === 0) {
          <div class="activity-empty">No recent activity</div>
        }
        @for (entry of activityLog.entries$ | async; track entry) {
          <div
            class="activity-entry"
            [class.activity-success]="entry.type === 'success'"
            [class.activity-error]="entry.type === 'error'"
          >
            <mat-icon class="activity-entry-icon">{{
              entry.icon ||
                (entry.type === 'success'
                  ? entry.action === 'create'
                    ? 'add_circle'
                    : entry.action === 'delete'
                      ? 'delete'
                      : entry.action === 'update'
                        ? 'edit'
                        : 'check_circle'
                  : 'error')
            }}</mat-icon>
            <div class="activity-entry-content">
              @if (entry.module) {
                <div class="activity-entry-module">{{ entry.module }}</div>
              }
              <div class="activity-entry-message">{{ entry.displayMessage }}</div>
              @if (entry.details) {
                <div class="activity-entry-details">
                  <span
                    class="activity-entry-details-text"
                    [matTooltip]="entry.details"
                    matTooltipPosition="below"
                    >{{ entry.details }}</span
                  >
                  @if (entry.copyValue) {
                    <button
                      class="activity-copy-btn"
                      mat-icon-button
                      [matTooltip]="copiedEntryId === entry.id ? 'Copied!' : 'Copy QC code'"
                      matTooltipPosition="below"
                      (click)="copyEntryCode(entry, $event)"
                      aria-label="Copy QC code"
                    >
                      <mat-icon>{{
                        copiedEntryId === entry.id ? 'check' : 'content_copy'
                      }}</mat-icon>
                    </button>
                  }
                </div>
              }
              <div class="activity-entry-time">{{ entry.timestamp | date: 'HH:mm' }}</div>
            </div>
          </div>
        }
      </div>
    </mat-menu>

    <button
      mat-icon-button
      (click)="toggleDarkMode()"
      class="header-icon-btn theme-toggle-button"
      [matTooltip]="isDarkMode ? 'Light mode' : 'Dark mode'"
      matTooltipPosition="below"
    >
      <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <button
      mat-icon-button
      [matMenuTriggerFor]="settingsMenu"
      class="header-icon-btn settings-button"
      matTooltip="Settings"
      matTooltipPosition="below"
    >
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #settingsMenu="matMenu" class="settings-menu-panel">
      <div class="settings-section-label" (click)="$event.stopPropagation()">Language</div>
      @for (lang of availableLanguages; track lang.languageCode) {
        <button
          mat-menu-item
          (click)="changeLanguage(lang)"
          [class.settings-lang-active]="lang.languageCode === selectedLanguage"
        >
          @if (lang.languageCode === selectedLanguage) {
            <mat-icon>check</mat-icon>
          }
          @if (lang.languageCode !== selectedLanguage) {
            <mat-icon style="opacity: 0">check</mat-icon>
          }
          {{ lang.languageName }}
        </button>
      }
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
